export default __webpack_public_path__ + "static/training-24141ce4e149e7c7e39e66f1db192367.png";